import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data: [],
    page: {
        page: 1,
        size: 10,
        totalPage: 1,
        totalSize: 1,
    }
};

const materialSlice = createSlice({
    name: 'material',
    initialState,
    reducers: {
        funGetMaterial(state, action){
            const { list, page, size, totalPage, totalSize } = action.payload;
            state.data = list.map(( material ) => {
                return{
                    ...material,
                }
            });
            state.page = { page, size, totalPage, totalSize };
        }
    },
});

export const materialActions = materialSlice.actions;
export default materialSlice.reducer;